export function downloadCSV(data: BlobPart, filename: string) {
    const blob = new Blob([data], { type: 'text/csv' })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.click()
}

async function toDataURL(url: string) {
    const blob = await fetch(url).then((res) => res.blob())
    return URL.createObjectURL(blob)
}

export async function forceDownload(url: string, fileName: string) {
    const a = document.createElement("a")
    a.href = await toDataURL(url)
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}
